import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import classNames from "classnames";
import TooltipBubble from "../../../../components/common/TooltipBubble";

export interface Props {
  type: "Total Transferred" | "Pending Transfer" | "Open Balance";
  amount: string;
  onClick?: () => void;
  loading?: boolean;
  fourCardLayout?: boolean; // Flag to indicate if this is in the 4-card layout
}

const WalletCard: React.FC<Props> = ({
  type,
  amount,
  onClick,
  loading,
  fourCardLayout = false,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const manualWithdrawFeatureEnabled = false;

  const { title, icon, content } = useMemo(() => {
    let title = "";
    let icon = "";
    let content = "";
    switch (type) {
      case "Total Transferred":
        title = t("balance_number_card_transfered_title");
        icon = "assets/images/svg/wallet_icon.png";
        content = t("balance_number_card_transfered_info");
        break;
      case "Open Balance":
        title = t("balance_number_card_open_title");
        icon = "assets/images/svg/blue_clock.svg";
        content = t("balance_number_card_open_info");
        break;
      case "Pending Transfer":
      default:
        title = t("balance_number_card_processing_title");
        icon = "assets/images/svg/inprocess.svg";
        content = t("balance_number_card_processing_info");
        break;
    }

    return { title, icon, content };
  }, [t, type]);

  const handleClick = useCallback(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    if (width < 992 || (width >= 1000 && height >= 1900)) {
      onClick && onClick();
    }
  }, [onClick]);

  return (
    <div
      className={classNames(
        styles["wallet_card"],
        type == "Open Balance" && styles["bg_blue"]
      )}
      onClick={handleClick}>
      <img src={icon} className={styles["icon"]} alt="wallet" />
      <div className={styles["text"]}>
        <div className={styles["header_section"]}>
          <p className={styles["title"]}>{title}</p>
          <div className={styles["mob_none"]}>
            <TooltipBubble
              content={content}
              position={type === "Total Transferred" ? "top" : "bottom"}
              trigger="hover"
              className={
                type === "Total Transferred"
                  ? fourCardLayout
                    ? "total-transferred-tooltip-four-card"
                    : "total-transferred-tooltip"
                  : ""
              }>
              <img
                alt="img"
                src="/assets/images/svg/exclamation_v2.svg"
                className={styles["info"]}
              />
            </TooltipBubble>
          </div>
          <div className={styles["mob_visible"]}>
            <img
              alt="img"
              src="/assets/images/svg/exclamation_v2.svg"
              className={styles["info"]}
            />
          </div>
        </div>
        <h1 className={classNames(loading && styles["loading_amount"])}>
          {amount}﷼
        </h1>
      </div>
    </div>
  );
};

export default WalletCard;
